import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import PrimaryTheme from '../Themes/Primary'
import SuccessMessage from "../images/Dashboard-success-icon.png"
export default function FloatAlert() {

    const recAndDeclineMessageReducer = useSelector((state: any) => state.recAndDeclineMessageReducer);
    const recAndDecline = useSelector((state: any) => state.recAndDecline)
    const dispatch = useDispatch()
    const handleCloseModal = () => {

        dispatch({
            type: 'ALERT_MODAL',
            payload: false
        });
        dispatch({
            type: 'SEND_REC_AND_DECLINED_MESSAGE',
            payload: {}
        });
    }
    return (
        <div>
            <div className="alert-image" style={{ paddingTop: "100px", marginBottom: "20px", display: "flex", justifyContent: "center" }}>
                <img src={SuccessMessage} alt="logo" />
            </div>
            <h2 style={{ fontSize: PrimaryTheme.fontSizes?.subtitle, color: PrimaryTheme.success, width: "100%", textAlign: "center" }}>{recAndDecline.recStatus === "Recommend" ? "Request Recommended Successfully" : "Request Declined"}</h2>
            <h6 style={{ fontSize: PrimaryTheme.fontSizes?.normal, color: "#818e94", width: "100%", textAlign: "center", paddingLeft: "21%", paddingRight: "21%" }}>
                {
                    recAndDecline.recStatus === "Recommend" ? "Your agent will instantly receive requested float amount into their account.A reminder would be sent to the agent to remind them of their repayment" : "Your Agent’s Float  Request has been declined"
                }


            </h6>
            <div style={{ paddingTop: "60px", paddingBottom: "40px", width: "100%", display: "flex", justifyContent: "center" }}>
                <button type="button" style={{
                    borderRadius: "20px 20px 20px 20px",
                    width: "50%",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    background: PrimaryTheme.warn,
                    color: PrimaryTheme.black,
                    border: "none"

                }} onClick={handleCloseModal} >Back</button>
            </div>
        </div>
    )
}
